import { useState } from 'react';
import type { FormEvent } from 'react';
import { useToast } from '@/app/providers/ToastProvider';
import { Button, Input, Modal } from '@/ui';

export interface RequestAccessModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
}

export function RequestAccessModal({ isOpen, onClose }: RequestAccessModalProps) {
  const toast = useToast();
  const [fullName, setFullName] = useState('');
  const [workEmail, setWorkEmail] = useState('');
  const [company, setCompany] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!workEmail.trim() || !fullName.trim()) return;

    setIsSubmitting(true);
    // Simulate prompt response & thank you
    setTimeout(() => {
      setIsSubmitting(false);
      toast.success(
        `Thank you ${fullName.trim()}! Your access request for ${company.trim() || 'your team'} has been submitted. Our onboarding team will contact you shortly.`,
        { title: 'Access Request Received' },
      );
      setFullName('');
      setWorkEmail('');
      setCompany('');
      onClose();
    }, 600);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Request access to LeadGen"
      subtitle="Discover and enrich verified decision-makers across thousands of organisations."
      maxWidth="480px"
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Input
          label="Full name"
          placeholder="Jane Doe"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          required
        />

        <Input
          label="Work email"
          type="email"
          placeholder="jane@company.com"
          value={workEmail}
          onChange={(e) => setWorkEmail(e.target.value)}
          required
        />

        <Input
          label="Company name"
          placeholder="Acme Corp"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '12px' }}>
          <Button variant="ghost" onClick={onClose} type="button">
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loading={isSubmitting}
            disabled={!fullName.trim() || !workEmail.trim()}
          >
            Submit request
          </Button>
        </div>
      </form>
    </Modal>
  );
}
